import React from "react";
import { Box, Button, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  IDataTableProps,
  RenderType,
} from "../../../../../../components/Table/interfaces/IDataTableProps";
import { DataTable } from "../../../../../../components/Table/DataTable";
import { useDispatchWrapper } from "../../../../../../hooks";
import { IStoreState } from "../../../../../../redux/initialStoreState";
import { useSelector } from "react-redux";
import { LoadState } from "../../../../../../constants/enums";
import { fetchBusinessPolicyUnderLyingListAsync } from "../../../../../../redux/businessPolicy/businessPolicyUnderLyingInsurance/businessPolicyUnderLyingInsuranceActions";
import { IBusinessPolicyUnderLying } from "../../../../../../redux/businessPolicy/businessPolicyUnderLyingInsurance/businessPolicyUnderLyingInsurance.types";
import { StandardTableActions } from "../../../../../../components/StandardTableActions/StandardTableActions";

export const UnderLyingList: React.FC<{
  customerId: number;
  customerPolicyId: number;
}> = (props) => {
  const { customerId, customerPolicyId } = props;
  const navigate = useNavigate();
  const { data, loading } = useSelector(
    (storeState: IStoreState) => storeState.business.underLying
  );
  const dispatch = useDispatchWrapper();

  React.useEffect(() => {
    dispatch(fetchBusinessPolicyUnderLyingListAsync(customerPolicyId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerPolicyId]);

  const underlyingProps: IDataTableProps = {
    isPagination: false,
    isDataLoading: loading === LoadState.InProgress,
    tableCommandBarProps: {
      leftItems: {},
      rightItems: {
        customPlugins: [
          {
            key: "status",
            onRender: () => (
              <Button
                variant="contained"
                onClick={() => {
                  navigate(
                    `/business-policy/${customerId}/schedule-tab/${customerPolicyId}/underlying`
                  );
                }}
              >
                Add Underlying Insurance
              </Button>
            ),
          },
        ],
      },
    },
    columns: [
      {
        key: "incremental_number",
        headerName: "#",
        fieldName: "incremental_number",
        renderType: RenderType.CUSTOM_RENDER,
        exportCellWidth: 15,
        onRowCellRender: (value, row: IBusinessPolicyUnderLying) => {
          return (
            <Link
              sx={{ cursor: "pointer" }}
              onClick={() =>
                navigate(
                  `/business-policy/${customerId}/schedule-tab/${customerPolicyId}/underlying/${row.incremental_number}`
                )
              }
            >
              {row.incremental_number}
            </Link>
          );
        },
      },

      {
        key: "insurer",
        headerName: "Insurer",
        fieldName: "insurer",
        renderType: RenderType.TEXT_DARK,
        exportCellWidth: 20,
      },
      {
        key: "policy_number",
        headerName: "Policy Number",
        fieldName: "policy_number",
        renderType: RenderType.TEXT,
        exportCellWidth: 20,
      },
     
      {
        key: "expiry_date",
        headerName: "Expiry Date",
        fieldName: "expiry_date",
        renderType: RenderType.DATE_TIME,
        exportCellWidth: 30,
      },

      {
        key: "insert_dt",
        headerName: "Created Date",
        fieldName: "insert_dt",
        renderType: RenderType.DATE,
        exportCellWidth: 30,
      },

 
      {
        key: "premium_amount",
        headerName: "Premium Amount",
        fieldName: "premium_amount",
        renderType: RenderType.TEXT,
        exportCellWidth: 20,
      },

      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        headingAlign: 'center',
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IBusinessPolicyUnderLying) => {


          return <StandardTableActions
          onEditClick={() => {
            navigate(
              `/business-policy/${customerId}/schedule-tab/${customerPolicyId}/underlying/${row.incremental_number}`
            );
          }}
        />
        },
      },
    ],
    items: data,
  };

  return (
    <>
      <Box sx={{ mt: 2 }}>
        <DataTable {...underlyingProps} />
      </Box>
    </>
  );
};
